import { AnyType } from 'src/globalTypes';

export const isString = (value: AnyType): value is string => typeof value === 'string';
